/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-06-12 15:49:18
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-06-13 09:43:21
 * @FilePath: \website\src\components\element\attrs\cpt-iframe-option.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
    cptDataForm: {
        dataText: '{"value":"https://www.rainy.pub/"}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/url',
        sql: 'select id from test limit 1'
    },
    attribute: {
        defaultValueType: null, 
        defaultValue: '',
        amountTo: null,
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
        isEllipsis:0,
        lineClamp:1,
        funcResult:null,
        getFatherUrlParams: '0'
    },
}